import React, { useState, useEffect, useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactDOM from 'react-dom'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import CloseButton from '../../layout/close_button/CloseButton'
import { ContentInner } from '../../layout/Content'
import { CustomerAccountCreditsListStyle, CustomerAccountCustomerDetailsStyle, CustomerLogStyle } from './css/CustomerAccountItemInnerStyle'
import { customerAccountItemControllerContext } from './CustomerAccountItemController'
import { appContext } from '../../../App'
import CustomerCreditAccountController from '../customer_credit_account/CustomerCreditAccountController'
import { saveCustomer } from '../CustomersAccountsFunctions'
import { formatNumber } from '../../utilities/utilities'

function CustomerAccountItemDetails() {
  const customerAccountItemController = useContext(customerAccountItemControllerContext)
  const { customerAccount } = customerAccountItemController

  return (
    <React.Fragment>
      <div className='customer-account-item-details-container'>
        <div className='label-content-container'>
          <label className='label'>Account Number</label>
          <div>{(customerAccount) && customerAccount._id.toUpperCase()}</div>
        </div>
        <div className='label-content-container'>
          <label className='label'>Account Name</label>
          <div>{(customerAccount) && customerAccount.customer_details.account_name}</div>
        </div>
        <div className='label-content-container'>
          <label className='label'>Present Address</label>
          <div>{(customerAccount) && customerAccount.customer_details.present_address}</div>
        </div>
        <div className='label-content-container'>
          <label className='label'>Contact Number</label>
          <div>{(customerAccount) && customerAccount.customer_details.contact_number}</div>
        </div>
        <div className='label-content-container'>
          <label className='label'>Email</label>
          <div>{(customerAccount) && customerAccount.customer_details.email}</div>
        </div>
        <div className='label-content-container'>
          <label className='label'>Contact Person's Name</label>
          <div>{(customerAccount) && customerAccount.customer_details.contact_persons_name}</div>
        </div>
        <div className='label-content-container'>
          <label className='label'>Contact Person's Number</label>
          <div>{(customerAccount) && customerAccount.customer_details.contact_persons_number}</div>
        </div>
        <div className='label-content-container'>
          <label className='label'>Credit Limit</label>
          <div id='credit-limit-container'>
            <div>{(customerAccount) && customerAccount.customer_details.credit_limit}</div>
          </div>
        </div>
      </div>
      <CustomerAccountCustomerDetailsStyle />
    </React.Fragment>
  )
}

function CustomerAccountCreditsList() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const customerAccountItemController = useContext(customerAccountItemControllerContext)
  const { customerAccount, refreshCustomerAccount } = customerAccountItemController
  const [refresh, setRefresh] = useState(false) // simple use to force rerender of component
  const [enableAddCreditAccountButton, setEnableAddCreditAccountButton] = useState(false)

  function TitleBar() {
    const onClickAddCreditAccount = () => {
      // Set a new customer credit account
      const client_date_time = new Date().toLocaleString('en-us', { timeZone: app.getClientTimezone(), dateStyle: "medium", timeStyle: "long" });
      customerAccount.credit_accounts.push(
        {
          date_time_created: client_date_time,
          client_timezone: app.getClientTimezone(),
          credit_account_number: new Date(client_date_time).getTime(),
          invoices: [],
          status: 'On Process'
        }
      );
      saveCustomer(app, customerAccount)
      .then(res => {
        refreshCustomerAccount()
        const customerCreditAccountControllerProps = {
          customerAccountId: customerAccount._id,
          creditAccountNumber: customerAccount.credit_accounts[customerAccount.credit_accounts.length - 1].credit_account_number
        }
        setContent(<CustomerCreditAccountController { ...customerCreditAccountControllerProps }/>)
      })
    }

    useEffect(() => {
      if (customerAccount) {
        if (customerAccount.credit_accounts.length === 0)
          setEnableAddCreditAccountButton(true)
        else {
          if (customerAccount.credit_accounts[customerAccount.credit_accounts.length - 1].invoices.length === 0)
            setEnableAddCreditAccountButton(false)
          else if (customerAccount.credit_accounts[customerAccount.credit_accounts.length - 1].invoices.length > 0)
            // Check here if there is still Balance
            // If there is still balance then setEnableAddCreditAccountButton(false)
            // else setEnableAddCreditAccountButton(true)
            if (customerAccount.credit_accounts[customerAccount.credit_accounts.length - 1].status === 'Settled')
              setEnableAddCreditAccountButton(true)
        }
      }
    })

    return (
      <div className='customer-accounts-list-title'>
        <span style={{marginRight: '10px'}}>Credit Accounts List</span>
        <button
          title='Add new credit account'
          className={ enableAddCreditAccountButton ? 'pospro-action-btn' : 'pospro-action-btn disabled-button' }
          disabled={!enableAddCreditAccountButton}
          onClick={onClickAddCreditAccount}>
          <FontAwesomeIcon icon='plus'/>
        </button>
      </div>
    )
  }

  const onClickCreditAccount = async (e) => {
    const deleteCreditButton = e.target.closest('.close-button')
    if (deleteCreditButton) return

    const creditItem = e.target.closest('.tbody-tr')
    customerAccount.action = 'edit'
    const credit_account = customerAccount.credit_accounts.find((ca) => (ca.credit_account_number === parseInt(creditItem.id)))


    if (credit_account.status === 'On Process') {
      // See who's the last to access this file
      const last_modifier = customerAccount.log.last_modified_by.name

      // Show custom messagebox here
      const onProcessInvoiceWarningMessage =
      <>
        You are trying to edit an "On Process" statused credit account, which is currently or last modified by <i>{last_modifier}</i>.<br/><br/>
        Please make sure this item is no longer active or open in other terminals.<br/><br/>
        If you force it, you and <i>{last_modifier}</i> might lose some data or may experience weird behaviours on the process. 
      </>

      const showMessageBox = (message) => {
        const onClick = (button) => {
          if (button === 'Yes') {
            saveCustomer(app, customerAccount)
            .then(res => {
              refreshCustomerAccount()
              const customerCreditAccountControllerProps = {
                customerAccountId: customerAccount._id,
                creditAccountNumber: parseInt(creditItem.id)
              }
              setContent(<CustomerCreditAccountController { ...customerCreditAccountControllerProps }/>)
            })
          }
          ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
        }

        ReactDOM.render (
          <ModalWindow
            id='mw-parent'
            heigh='40'
            width='40'
            header="Edit Credit Account"
            footer={null}>
            <div className='messagebox'>
              <div className='messagebox-content'>
                <div style={{color: 'red'}}>Warning!</div>
                <div>{ message }</div>
                <br/>
                <div>Are you sure you want to continue?</div>
              </div>
              <div className='button-container'>
                <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
                <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
              </div>
            </div>
          </ModalWindow>,
          document.getElementById('modal-form-container')
        )
      }
      showMessageBox(onProcessInvoiceWarningMessage)
    } else {
      credit_account.status = (credit_account.status !== 'Settled') ? 'On Process' : 'Settled'
      saveCustomer(app, customerAccount)
      .then(res => {
        refreshCustomerAccount()
        const customerCreditAccountControllerProps = {
          customerAccountId: customerAccount._id,
          creditAccountNumber: parseInt(creditItem.id)
        }
        setContent(<CustomerCreditAccountController { ...customerCreditAccountControllerProps }/>)
      })
    }
    // There is no obvious reason to use variable to saveCustomer() results
    // but for some strange reason it only works right if I do so
    //const customer_account = await saveCustomer(customerAccount, app)
    //await saveCustomer(customerAccount, app)
  }

  const onClickDeleteCreditAccount = (e) => {
    const deleteCreditButton = e.target.closest('.close-button')

    const onClick = (button) => {
      if (button === 'Yes') deleteSelectedCreditAccount()
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
    }

    const deleteSelectedCreditAccount = () => {
      const id = parseInt(deleteCreditButton.parentNode.parentNode.id)
      customerAccount.credit_accounts = customerAccount.credit_accounts.filter(credit_account => credit_account.credit_account_number !== id)
      saveCustomer(app, customerAccount)
      refreshCustomerAccount()
      setRefresh(true)
    }

    const showMessageBox = () => {
      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          header="Delete Record"
          footer={null}>
            <div className='messagebox'>
              <div className='messagebox-content'>
                <div>Selected credit account will be deleted!</div>
                <br/>
                <div>Do you want to continue?</div>
              </div>
              <div className='button-container'>
                <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
                <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
              </div>
            </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    showMessageBox()
  }

  useEffect(() => { if (refresh) setRefresh(false) }, [refresh])

  return (
    <React.Fragment>
      <div className='customer-accounts-credits-list-container'>
        <TitleBar />
        <table className='table striped-table'>
          <thead>
            <tr>
              <th className='empty-header' style={{textAlign: 'left'}}>Date Created</th>
              <th className='empty-header'>Number</th>
              <th className='empty-header' style={{textAlign: 'center'}}>Invoices</th>
              <th className='empty-header' style={{textAlign: 'left'}}>Due Date</th>
              <th className='empty-header' style={{textAlign: 'right'}}>Total Amount</th>
              <th className='empty-header' style={{textAlign: 'right'}}>Balance</th>
              <th className='empty-header' style={{textAlign: 'center'}}>Status</th>
              <th className='empty-header'>Actions</th>
            </tr>
          </thead>
          {
            (customerAccount) ?
            customerAccount.credit_accounts.map((credit_account) => (
              <tbody key={credit_account.credit_account_number}>
                <tr
                  id={credit_account.credit_account_number}
                  onClick={onClickCreditAccount}
                  className='tbody-tr'>
                  <td>
                    <div>{new Date(credit_account.date_time_created).toLocaleString("en-us", { timeZone: credit_account.client_timezone })}</div>
                    <div style={{ fontSize: "0.8em" }}>{ credit_account.client_timezone }</div>
                  </td>
                  <td>{credit_account.credit_account_number}</td>
                  <td style={{textAlign: 'center'}}>{credit_account.invoices.length}</td>
                  <td>May 5, 2021</td>
                  <td style={{textAlign: 'right'}}>P{formatNumber(credit_account.total_amount)}</td>
                  <td style={{textAlign: 'right'}}>P{formatNumber(credit_account.total_balance)}</td>
                  <td style={{textAlign: 'center'}}>
                    <div className={(credit_account.status === 'Unsettled')
                      ? 'status unsettled'
                      : (credit_account.status === 'Settled')
                        ? 'status settled'
                        : 'status on-process'}>
                      {credit_account.status}
                    </div>
                  </td>
                  <td style={{textAlign: 'center'}}>
                  {
                    (credit_account.invoices.length) ? null
                    : <CloseButton onClick={onClickDeleteCreditAccount} title='delete credit account'/>
                  }
                  </td>
                </tr>
              </tbody>
            ))
            : null 
          }
        </table>
      </div>
      <CustomerAccountCreditsListStyle />
    </React.Fragment>
  )
}

function CustomerLog() {
  const customerAccountItemController = useContext(customerAccountItemControllerContext)
  const { customerAccount } = customerAccountItemController

  return (
    <React.Fragment>
      {
        (customerAccount)
        ? <div className='log-container'>
            <div className='created-by'>
              Created by {customerAccount.log.created_by.name} on {new Date(customerAccount.date_time_created).toLocaleString("en-us", { timeZone: customerAccount.client_timezone })} { customerAccount.client_timezone }
            </div>
            {
              (customerAccount.log.last_modified_by)
              ? <div className='last-modified-by'>
                  Last modified by {customerAccount.log.last_modified_by.name} on {new Date(customerAccount.date_time_modified).toLocaleString("en-us", { timeZone: customerAccount.client_timezone })} { customerAccount.client_timezone }
                </div>
              : null
            }
          </div>
        : null
      }
      <CustomerLogStyle />
    </React.Fragment>
  )
}

function CustomerAccountItemInner() {
  return(
    <ContentInner>
      <CustomerAccountItemDetails />
      <CustomerAccountCreditsList />
      <CustomerLog />
    </ContentInner>
  )
}

export default React.memo(CustomerAccountItemInner)
